'use client';

import { useEffect, useRef } from 'react';

import { initializeAuth } from '@/utils/auth/init.util';

export function useAuthInit() {
  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) {
      return;
    }

    hasInitialized.current = true;
    initializeAuth();
  }, []);
}
